import { toast } from "react-toastify";
import { createSlice } from '@reduxjs/toolkit';
import RemittanceService from "../../services/RemittanceService";  


interface APIResponse {
    data: {
        status: number,
        message: string,
        data?: any
    }
}

const Remittance = createSlice({
    name: 'remittance',
    initialState: {
        remittanceList: {},
        remittanceDetail: {},
        remittanceRibbon: {}
    },
    reducers: {
        remittanceList: (state, action) => {
            state.remittanceList = action.payload
        },
        setRemittanceDetail: (state, action) => {
            state.remittanceDetail = action.payload
        },
        setRemittanceRibbon: (state, action) => {
            state.remittanceRibbon = action.payload
        }
    }
})

export default Remittance.reducer;

const { remittanceList,setRemittanceDetail,setRemittanceRibbon } = Remittance.actions

/**
 * Handle to save Remittance Payment
 * @param params 
 * @returns 
 */
export const saveRemittancePayment = (params: object) => {
    return new Promise((resolve, reject) => {
        RemittanceService.saveRemittancePayment(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        toast.success(response.data.message)
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

/**
 * Handle to fetch remittance detail
 * @param params 
 * @returns 
 */
export const fetchRemittanceDetail = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {        
        RemittanceService.fetchRemittanceDetail(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response?.data?.data?.remittanceData)
                        dispatch(setRemittanceDetail(response?.data?.data?.remittanceData));
                        dispatch(setRemittanceRibbon(response?.data?.data?.ribbonData));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

/**
 * Handle to save Remittance Details
 * @param params 
 * @returns 
 */
export const saveRemittanceDetails = (params: object) => {
    return new Promise((resolve, reject) => {
        RemittanceService.saveRemittanceDetails(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        toast.success(response.data.message)
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

/**
 * Function to make API call to fetch insurance listing
 * @param params 
 * @returns 
 */
export const getRemittanceList = (params: object) => async (dispatch: any) => {
    return new Promise((resolve, reject) => {        
        RemittanceService.getRemittanceList(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        resolve(response.data)
                        dispatch(remittanceList(response.data));
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

/**
 * Handle to assign lead
 * @param params 
 * @returns 
 */
export const assignLead = (params: object) => {
    return new Promise((resolve, reject) => {
        RemittanceService.assignLead(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        toast.success(response.data.message)
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

/**
 * Handle to Download Soa
 * @param params 
 * @returns 
 */
export const downloadSoa = (params: object) => {
    return new Promise((resolve, reject) => {
        RemittanceService.downloadSoa(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        toast.success(response.data.message)
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}

export const bulkRemittanceAssignee = async (params: object) => {
    return new Promise((resolve, reject) => {
        RemittanceService.bulkRemittanceAssignee(params)
            .then(
                (response: APIResponse) => {
                    if ((response && response.data && response.data.status) === 200) {
                        toast.success(response.data.message);
                        resolve(response.data)
                    }
                    else {
                        let errorMsg = (response && response.data && response.data.message) || ''
                        if (errorMsg) toast.error(response.data.message);
                        resolve(response && response.data)
                    }
                },
                (error: Error) => {
                    reject(error);
                }
            )
    })
}